import React, { useMemo } from 'react'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import { pick } from 'lodash-es'
import useProjectStore from '@vt/hooks/lib/project/use-project-store'
import { downloadFile, getDownloadUrl } from '@vt/apis/lib-ex/v2/givrali'
import { File, FileNew } from '@ow/ditto'

const TableContainer = function () {
  const {
    tbData,
    filelistConfig,
    fileMap,
    operatorConfig,
    destroyTbData,
    fileConfig,
    loading,
  } = useTbViewStore((state) =>
    pick(state, [
      'tbData',
      'filelistConfig',
      'fileMap',
      'operatorConfig',
      'destroyTbData',
      'fileConfig',
      'loading',
    ])
  )
  const { appId } = useAppEx()
  const { getToken } = useProjectStore((s) => pick(s, ['getToken']))
  const token = getToken()

  const showDelete = useMemo(() => {
    const { operatorConfig: config } = operatorConfig || {}
    return (
      config && (config.elements || []).find((v) => v.actionType === 'delete')
    )
  }, [operatorConfig])

  return fileConfig ? (
    <FileNew
      tbData={tbData}
      fileConfig={fileConfig}
      loading={loading}
      onClickDelete={(key) => {
        destroyTbData(key)
      }}
    />
  ) : (
    <File
      tbData={tbData}
      fileMap={fileMap}
      fileConfig={filelistConfig}
      showDelete={showDelete}
      onClickdownload={(downloadUrl) => {
        const url = downloadUrl.split('?') && downloadUrl.split('?')[0]
        window.open(downloadFile(appId, url, token))
      }}
      onClickDelete={(key) => {
        destroyTbData(key)
      }}
      onClickdownloadIcon={(media) => {
        const fileName = media[0] && media[0].filename
        const fileLink = media[0] && media[0].src && media[0].src.split('?')[0]
        window.open(getDownloadUrl(appId, fileName, fileLink, token))
      }}
    />
  )
}

export default TableContainer
